$(document).ready(function(){
  setTimeout(function(){
    if(document.body.classList.contains('template-product')){
    
    /* HC - Product carousel adjustments - 17 Jan '23 */
    $('.hc-product-carousel').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: true,
        lazyLoad: 'progressive',
        infinite: true,
        asNavFor: '.hc-product-gallery__nav'
      });
      $('.hc-product-gallery__nav').slick({
        slidesToShow: 5,
        slidesToScroll: 1,
        asNavFor: '.hc-product-carousel',
        variableWidth: true,
        dots: false,
        arrows:true,
        lazyLoad: 'progressive',
        infinite: true,
        // centerMode: true,
        focusOnSelect: true,
        responsive: [
           {
             breakpoint: 767,
             settings: {
               slidesToShow: 4,
               slidesToScroll: 1
             }
           },
           {
             breakpoint: 480,
             settings: {
               slidesToShow: 3,
               slidesToScroll: 1
             }
           }
        ]
      });
  }}, 200);

  let i = $(`.product-gallery__image--active`).data('slick-index');
  if($('.hc-product-carousel').length > 0){
    $('.hc-product-carousel').slick('slickGoTo', i);
  }
  
if($('[data-fancybox]').length > 0){
  $('[data-fancybox]').fancybox({
    // Options will go here
    buttons : [
      'close'
    ],
    wheel : false,
    transitionEffect: "slide",
    // thumbs          : false,
    // hash            : false,
    loop            : true,
    // keyboard        : true,
    toolbar         : false,
    // animationEffect : false,
    // arrows          : true,
    clickContent    : false
  });
  }
  
  if($('.desc_main table').length > 1){
    let html = $('.desc_main table').html();
    if(html != undefined){
      $('.desc_main table').eq(0).replaceWith(`<div class="option_table"><table width="100%">${html}</html></div>`);
    }
  }
  $('.sidebar-block .toggle').on('click', function(){
    $(this).next('.toggle_list').slideToggle('slow');
  });
});
